import { render, staticRenderFns } from "./DropIn.vue?vue&type=template&id=5b84d73c"
import script from "./DropIn.vue?vue&type=script&lang=js"
export * from "./DropIn.vue?vue&type=script&lang=js"
import style0 from "./DropIn.vue?vue&type=style&index=0&id=5b84d73c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports